import { useState } from "react";
import { Snowfall } from "react-snowfall/lib/Snowfall";

import flake1 from "../../assets/snow/snowflake-1.png";
import flake2 from "../../assets/snow/snowflake-2.png";
import flake3 from "../../assets/snow/snowflake-3.png";
import kcFlake from "../../assets/snow/kc-flake.png";
import { useSnowOverlay } from "../../context/SnowOverlayContext";
import kcFlake2 from "../../assets/snow/kc-flake-2.png";

const snowflake1 = document.createElement("img");
snowflake1.src = flake1;
const snowflake2 = document.createElement("img");
snowflake2.src = flake2;
const snowflake3 = document.createElement("img");
snowflake3.src = flake3;

const kcSnowflake = document.createElement("img");
kcSnowflake.src = kcFlake;
const kcSnowflake2 = document.createElement("img");
kcSnowflake2.src = kcFlake2;

const images = [snowflake1, snowflake2, snowflake3, kcSnowflake, kcSnowflake2];

const SnowyOverlay = () => {
  // Only show in December
  const isDecember =
    typeof window !== "undefined" && new Date().getMonth() === 11;
  const { enabled: snowVisible, toggle } = useSnowOverlay();
  const [tooltip, setTooltip] = useState(false);

  // Only loading in December
  if (!isDecember) return null;

  return (
    <>
      {/* Button for turning snow effect on/off */}
      <button
        onMouseOver={() => setTooltip(true)}
        onMouseOut={() => setTooltip(false)}
        onClick={toggle}
        className="fixed top-0 left-0 w-[100px] h-[30px] z-[100]"
      >
        <div
          className={`w-[35px] h-[35px] rotate-[-45deg] absolute top-[10px]  left-[8px]`}
        >
          <div
            className={`bg-[gray]   radius-[20px] ease duration-500 transition-width ${snowVisible ? "w-[0%] h-0" : "w-[100%] h-[2px]"}`}
          />
        </div>

        <img src={flake1} alt="Snowflake 1" className="max-h-[30px] w-auto" />

        <span
          role="tooltip"
          className={`absolute left-[40px] top-[5px] bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-[101] ease-in-out duration-500 transition-opacity ${tooltip ? "opacity-100" : "opacity-0"}`}
          style={{ pointerEvents: "none" }}
        >
          {snowVisible ? "Turn off snow effect" : "Turn on snow effect"}
        </span>
      </button>

      {/* The snow effect */}

      {snowVisible && (
        <Snowfall
          snowflakeCount={200}
          images={images}
          rotationSpeed={[1, 1]}
          style={{ zIndex: 999 }}
          radius={[14, 14]}
        />
      )}
    </>
  );
};

export default SnowyOverlay;
